import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { IOrgRole } from "interfaces"
import { Link } from "react-router-dom"
import moment from 'moment';
import { isHaveActionPermission } from "utills/helpers";

interface OrgRoleCardProps {
  data?: IOrgRole[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const RoleCard = ({data = [], pageSize = 10, currentPage = 1, _toggleActive }: OrgRoleCardProps) => {
  return (
    <ul
      className="bg-white"
    >
      {data.map((role: IOrgRole, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <div>
              <SwitchButton
                checked={role.is_active}
                disabled={
                  !isHaveActionPermission(
                    "role_management",
                    "organization",
                    "edit"
                  )
                }
                onChange={() => _toggleActive(role.id, role.is_active)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <Link to={`/organization/roles/${role.id}`} target="_blank" className="w-fit">
                <span className="sr-only">View Role</span>
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission(
                "role_management",
                "organization",
                "edit"
              ) ? (
                <Link
                  to={`/organization/roles/${role.id}/edit`}
                  target="_blank"
                  className="w-fit"
                >
                  <span className="sr-only">Edit Role</span>
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Role Name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{role.name}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Org Name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{role.organization_name}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Created at
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {moment(role.created).format("DD/MM/YYYY HH:mm:ss")}
            </p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Created by
            </p>
            <p className="flex-1 text-right text-sm leading-6">{role.created_by}</p>
          </li>
          <li className="relative flex items-center justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Updated at
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {moment(role.updated).format("DD/MM/YYYY HH:mm:ss")}
            </p>
          </li>
        </div>
      ))}
    </ul>
  )
}